import { render, staticRenderFns } from "./TutorIAWelcome.vue?vue&type=template&id=faf7aac6&scoped=true"
import script from "./TutorIAWelcome.vue?vue&type=script&lang=js"
export * from "./TutorIAWelcome.vue?vue&type=script&lang=js"
import style0 from "./TutorIAWelcome.vue?vue&type=style&index=0&id=faf7aac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf7aac6",
  null
  
)

export default component.exports